define('SageDotCom/Components/Listing/PageFacets',["jquery", "eventManager", "jsCookie", "SageDotCom/DataLayer/tealium", "SageDotCom/DataLayer/Events/searchRefinement", "SageDotCom/DataLayer/Util/trackingHelper"],
    function ($, eventManager, jsCookie, tealium, eventSchema, trackingHelper) {

        function PageFacets(scope) {

            $(scope).on("click", ".funnelback-refine-btn", function () {
                jsCookie.set("page-facets", "open");
            });

            $(scope).on("click", ".funnelback-return-btn", function () {
                jsCookie.remove("page-facets");
            });

            // whenever checkboxes change, push data to tealium
            $(":checkbox", scope).change(function (event) {
                if (event.currentTarget) {
                    var refinements = $(event.currentTarget).attr("data-tracking-refinement");
                    if (refinements) {
                        // format refinements for tealium
                        var refinementValue = decodeURIComponent(refinements); // remove any url encoding
                        refinementValue = refinementValue.replace(/\?/g, ''); // remove question mark
                        refinementValue = refinementValue.replace(/\&/g, '; '); // convert delimiter to semi colon
                        refinementValue = refinementValue.replace(/\=/g, ': '); // swap equals for colon
                        refinementValue = refinementValue.trim();
                        refinementValue = refinementValue.replace(/\;$/, ''); // remove any trailing semi colon
                        var eventObj = eventSchema.GenerateEventMetadata(event.currentTarget, null, refinementValue, window.location.href);
                        tealium.event(eventObj);
                    }
                }
            });

            $(".reset-filters", scope).click(function(event) {
                var eventObj = eventSchema.GenerateEventMetadata(event.currentTarget, null, 'clear', window.location.href);
                tealium.event(eventObj);
            });

            trackingHelper.registerTracking(scope, eventSchema.getName());
        }


        PageFacets.init = function init(args) {
            return args.IsEditorEditing === true
                ? null
                : new PageFacets(args.scope);
        };

        return PageFacets;
});
